import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import { companyOptions } from '../CommonFile/DropdownValues';

const Company = ({ companies, setCompanies, companyInput, setCompanyInput, companySizes, setCompanySizes, companySizeFrom, setCompanySizeFrom, companySizeTo, setCompanySizeTo, revenues, setRevenues, revenueFrom, setRevenueFrom, revenueTo, setRevenueTo, viewResult }) => {
    const handleRemove = (item, setter) => {
        setter((prev) => prev.filter((val) => val !== item));
    };

    const handleAddSingle = (value, setter, resetInput) => {
        if (value.trim()) {
            setter((prev) => (prev.includes(value.trim()) ? prev : [...prev, value.trim()]));
            resetInput('');
        }
    };

    const handleAddRange = (from, to, setter, resetFrom, resetTo) => {
        if (from && to) {
            const range = `${from} - ${to}`;
            setter((prev) => (prev.includes(range) ? prev : [...prev, range]));
            resetFrom('');
            resetTo('');
        }
    };

    return (
        <div className="search-contact-filter-container-second-third-div  mt-4">
            <div className="search-contact-filter-container-second-third-inner-div">
                <h6>🏬 Companies and Size</h6>
            </div>

            <Form className="search-contact-form-container">
                <Row className="mb-3">
                    <Col md={viewResult ? 12 : 6}>
                        {/* <Form.Group controlId="companyName">
                            <Form.Label className="pb-2 pt-2">Company Name</Form.Label>
                            <div className="type-head-selected-container mb-2">
                                {companies.map((item, index) => (
                                    <div key={index} className="type-head-selected-options">
                                        <span className="cross-mark" onClick={() => handleRemove(item, setCompanies)}>
                                            &times;
                                        </span>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <Form.Control
                                    type="text"
                                    placeholder="Enter company name"
                                    value={companyInput}
                                    onChange={(e) => setCompanyInput(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                            handleAddSingle(companyInput, setCompanies, setCompanyInput);
                                        }
                                    }}
                                />
                                <Button
                                    className="btn btn-primary"
                                    onClick={() => handleAddSingle(companyInput, setCompanies, setCompanyInput)}
                                >
                                    {viewResult ? <i className="fa fa-plus"></i> : "Add"}
                                </Button>
                            </div>
                        </Form.Group> */}


                        <Form.Group controlId="companyName">
                            <Form.Label className="pb-2 pt-2">
                                Company Name
                            </Form.Label>

                            {/* Display selected companies */}
                            <div className="type-head-selected-container mb-2">
                                {companies.map((item) => (
                                    <div
                                        key={item}
                                        className="type-head-selected-options"
                                    >
                                        <span
                                            className="cross-mark"
                                            role="button"
                                            onClick={() => handleRemove(item, setCompanies)}
                                        >
                                            &times;
                                        </span>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>

                            {/* Search existing companies or add a new one */}
                            <div className="d-flex align-items-center gap-2">
                                <Typeahead
                                    id="company-typeahead"
                                    className="w-100"
                                    flip={true}
                                    options={companyOptions
                                        .map((option) => option.label)
                                        .filter(
                                            (name) =>
                                                !companies.some(
                                                    (company) =>
                                                        company.toLowerCase() === name.toLowerCase()
                                                )
                                        )}
                                    placeholder="Search or enter a company name"
                                    allowNew
                                    newSelectionPrefix="Add new company: "
                                    onInputChange={(value) => setCompanyInput(value)}
                                    onChange={(selected) => {
                                        if (selected.length === 0) return;

                                        const companyName =
                                            typeof selected[0] === "string"
                                                ? selected[0].trim()
                                                : selected[0].label.trim();

                                        if (!companyName) return;

                                        setCompanies((prev) => {
                                            const alreadyExists = prev.some(
                                                (company) =>
                                                    company.toLowerCase() ===
                                                    companyName.toLowerCase()
                                            );

                                            return alreadyExists
                                                ? prev
                                                : [...prev, companyName];
                                        });

                                        setCompanyInput("");
                                    }}
                                    selected={[]}
                                    inputProps={{
                                        autoComplete: "off"
                                    }}
                                />
                            </div>
                        </Form.Group>

                    </Col>
                </Row>

                <Row className="mb-3">
                    {/* Company Size */}
                    <Col md={viewResult ? 12 : 6}>
                        <Form.Group controlId="companySize">
                            <Form.Label className="pb-2 pt-2">Company Size (From - To)</Form.Label>
                            <div className="type-head-selected-container mb-2">
                                {companySizes.map((item, index) => (
                                    <div key={index} className="type-head-selected-options">
                                        <span className="cross-mark" onClick={() => handleRemove(item, setCompanySizes)}>
                                            &times;
                                        </span>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <Form.Control
                                    type="number"
                                    placeholder="From"
                                    value={companySizeFrom}
                                    onChange={(e) => setCompanySizeFrom(e.target.value)}
                                />
                                <Form.Control
                                    type="number"
                                    placeholder="To"
                                    value={companySizeTo}
                                    onChange={(e) => setCompanySizeTo(e.target.value)}
                                />
                                <Button
                                    className="btn btn-primary"
                                    onClick={() =>
                                        handleAddRange(companySizeFrom, companySizeTo, setCompanySizes, setCompanySizeFrom, setCompanySizeTo)
                                    }
                                >
                                    {viewResult ? <i className="fa fa-plus"></i> : "Add"}
                                </Button>
                            </div>
                        </Form.Group>
                    </Col>

                    {/* Revenue */}
                    <Col md={viewResult ? 12 : 6}>
                        <Form.Group controlId="revenue">
                            <Form.Label className="pb-2 pt-2">Revenue (From - To)</Form.Label>
                            <div className="type-head-selected-container mb-2">
                                {revenues.map((item, index) => (
                                    <div key={index} className="type-head-selected-options">
                                        <span className="cross-mark" onClick={() => handleRemove(item, setRevenues)}>
                                            &times;
                                        </span>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <Form.Control
                                    type="number"
                                    placeholder="From"
                                    value={revenueFrom}
                                    onChange={(e) => setRevenueFrom(e.target.value)}
                                />
                                <Form.Control
                                    type="number"
                                    placeholder="To"
                                    value={revenueTo}
                                    onChange={(e) => setRevenueTo(e.target.value)}
                                />
                                <Button
                                    className="btn btn-primary"
                                    onClick={() =>
                                        handleAddRange(revenueFrom, revenueTo, setRevenues, setRevenueFrom, setRevenueTo)
                                    }
                                >
                                    {viewResult ? <i className="fa fa-plus"></i> : "Add"}
                                </Button>
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default Company;
